<div class="modal-header">
  <h5 *ngIf="user"
      id="editUserLabel"
      class="modal-title"
      i18n="@@EditUserFullName">
    Benutzer "{{ user.fullName }}" bearbeiten
  </h5>

  <button type="button"
          id="x_close"
          class="btn-close"
          (click)="onCancelClick()"
          data-bs-dismiss="modal"
          aria-label="Close"></button>
</div>

<div class="modal-body">
  <app-edit-user #editUserComponent
                 [customerId]="customerId"
                 (entityLoadedEvent)="onEntityLoadedEvent($event)">
  </app-edit-user>
</div>

<form *ngIf="formCreated"
      [formGroup]="formService.form"
      (ngSubmit)="editUserComponent.onSubmit(formService.form.value)">
  <div class="modal-footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-5 float-left">
          <button *ngIf="!isMasterUser"
                  type="button"
                  id="delete"
                  class="btn bg-danger text-white col-lg-3 btn-margin"
                  (click)="openDeleteDialog()"
                  [disabled]="isSupporter"
                  ngbTooltip="Durch das ausladen wird der Benutzer von Ihrem Ladepark getrennt"
                  i18n="@@DeleteUserButton">
            <app-svg source="icons/feather/trash-2" height="18"></app-svg><span class="ps-2 d-none d-lg-inline">{{ getDelButtonText() }}</span>
          </button>
        </div>
        <div class="col-7">
          <div class=" float-right float-end">
            <button *ngIf="this.user.email != null && this.user.email?.length > 0"
                    type="button"
                    id="reinvite"
                    class="btn btn-yellow col-lg-3 btn-margin"
                    (click)="sendInviteEmail()"
                    ngbTooltip="Diesen Benutzer erneut eine Einladungsdmail senden"
                    i18n="@@Re-InviteButton">
              <app-svg source="icons/feather/mail" height="18"></app-svg><span class="ps-2 d-none d-lg-inline">Erneut einladen</span>
            </button>

            <button type="submit"
                    id="save"
                    class="btn btn-save col-lg-3 btn-margin"
                    [disabled]="!formService.form.valid || !formService.unsavedChanges || editUserComponent.isBtnSaveDisabled || isSupporter"
                    ngbTooltip="Speichern der Änderungen an diesem Benutzer"
                    i18n="@@SaveChangesButton">
                      <app-svg source="icons/feather/save" height="18"></app-svg><span class="ps-2 d-none d-lg-inline">Änderungen speichern</span>
            </button>
          </div>
        </div>
      </div>
      </div>
    </div>
</form>
